/* ND TCG — JS del tema Shopify: menú, buscador, cookies, popup, carrito AJAX, galería, eventos, formulario de venta. */
(function () {
  'use strict';
  var ND = window.ND || {};

  /* ---------- utilidades ---------- */
  function hasCookie(n) { return document.cookie.split('; ').some(function (r) { return r.indexOf(n + '=') === 0; }); }
  function setCookie(n, v, days) { document.cookie = n + '=' + v + ';path=/;max-age=' + (60 * 60 * 24 * days) + ';SameSite=Lax'; }
  function money(cents) {
    var fmt = ND.moneyFormat || '{{amount_with_comma_separator}} €';
    var n = (cents / 100);
    var out;
    if (fmt.indexOf('no_decimals') > -1) { out = String(Math.round(n)); }
    else if (fmt.indexOf('with_comma_separator') > -1) { out = n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
    else { out = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
    return fmt.replace(/\{\{\s*[^}]+\s*\}\}/, out);
  }
  function refreshCartCount() {
    fetch(ND.cartGetUrl || '/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('#nd-cart-count').forEach(function (el) { el.textContent = c.item_count; });
      }).catch(function () {});
  }

  /* ---------- cabecera ---------- */
  function initHeader() {
    var b = document.getElementById('nd-burger'), m = document.getElementById('nd-mmenu');
    if (b && m) { b.addEventListener('click', function () { m.classList.toggle('open'); }); }
    var f = document.querySelector('.nd-search');
    if (f) {
      var ic = f.querySelector('.nd-search-ic');
      var inp = f.querySelector('input[type=search]');
      ic.addEventListener('click', function (e) {
        if (window.matchMedia('(max-width:980px)').matches) {
          e.preventDefault();
          f.classList.toggle('open');
          if (f.classList.contains('open')) { inp.focus(); }
        } else if (!inp.value.trim()) { e.preventDefault(); inp.focus(); }
        else { f.submit(); }
      });
    }
  }

  /* ---------- cookies ---------- */
  function initCookies() {
    var cbar = document.getElementById('nd-cookies');
    if (!cbar) { return; }
    if (!hasCookie('nd_cookie')) { cbar.hidden = false; }
    cbar.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cookie]'); if (!btn) { return; }
      setCookie('nd_cookie', btn.getAttribute('data-cookie'), 180);
      cbar.hidden = true;
    });
  }

  /* ---------- popup de novedades ---------- */
  function initPopup() {
    var pop = document.getElementById('nd-popup');
    if (!pop) { return; }
    function closePop(days) { pop.hidden = true; if (days) { setCookie('nd_popup', '1', days); } }
    var posted = pop.getAttribute('data-posted') === '1';
    if (posted) {
      pop.hidden = false;
      setCookie('nd_popup', '1', 365);
      setTimeout(function () { closePop(365); }, 2200);
    } else if (!hasCookie('nd_popup')) {
      setTimeout(function () { pop.hidden = false; }, (parseInt(ND.popupDelay, 10) || 8) * 1000);
    }
    pop.querySelector('.nd-popup-close').addEventListener('click', function () { closePop(7); });
    pop.addEventListener('click', function (e) { if (e.target === pop) { closePop(7); } });
  }

  /* ---------- añadir al carrito (AJAX) ---------- */
  function addToCart(form, btn, onDone) {
    var fd = new FormData(form);
    if (btn) { btn.classList.add('loading'); btn.disabled = true; }
    return fetch(ND.cartAddUrl || '/cart/add.js', {
      method: 'POST', credentials: 'same-origin', body: fd,
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (btn) { btn.classList.remove('loading'); btn.disabled = false; }
        if (!res.ok) { throw new Error(res.data && (res.data.description || res.data.message) || 'Error'); }
        refreshCartCount();
        if (onDone) { onDone(res.data); }
        return res.data;
      })
      .catch(function (err) {
        if (btn) { btn.classList.remove('loading'); btn.disabled = false; }
        alert(err.message || 'No se pudo añadir al carrito.');
      });
  }

  function showCartMsg(name) {
    var box = document.getElementById('nd-cartmsg');
    if (!box) { return; }
    var strong = box.querySelector('strong');
    if (strong) { strong.textContent = name; }
    box.hidden = false;
    box.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function initAjaxCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.classList.contains('nd-ajax-add')) { return; }
      e.preventDefault();
      var btn = form.querySelector('[type=submit]');
      var name = form.getAttribute('data-name') || '';
      addToCart(form, btn, function () {
        if (btn) {
          var prev = btn.textContent;
          btn.classList.add('added');
          btn.textContent = btn.getAttribute('data-added') || '✓';
          setTimeout(function () { btn.classList.remove('added'); btn.textContent = prev; }, 1600);
        }
        if (form.classList.contains('nd-pdp-form')) { showCartMsg(name); }
      });
    });

    // Selector de variante en la ficha: actualiza precio y disponibilidad.
    var sel = document.querySelector('.nd-pdp-form select[name=id]');
    if (sel) {
      sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        var price = document.querySelector('.pdp-sum .price .amount');
        var btn = document.querySelector('.nd-pdp-form .add-btn');
        if (price && opt.getAttribute('data-price')) { price.textContent = money(parseInt(opt.getAttribute('data-price'), 10)); }
        if (btn) {
          var av = opt.getAttribute('data-available') === '1';
          btn.disabled = !av;
          btn.textContent = av ? (btn.getAttribute('data-label') || 'Añadir al carrito') : 'Agotado';
        }
      });
    }
  }

  /* ---------- galería de la ficha ---------- */
  function initGallery() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('.nd-gthumb'); if (!b) { return; }
      var w = b.closest('.nd-gallery'); if (!w) { return; }
      var img = w.querySelector('.nd-gmain img');
      if (img) { var f = b.getAttribute('data-full'); img.src = f; img.srcset = f; img.removeAttribute('sizes'); }
      w.querySelectorAll('.nd-gthumb').forEach(function (t) { t.classList.remove('active'); });
      b.classList.add('active');
    });
  }

  /* ---------- orden en colecciones ---------- */
  function initSort() {
    var s = document.getElementById('nd-sort');
    if (!s) { return; }
    s.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', s.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
    if (window.matchMedia('(min-width:761px)').matches) {
      document.querySelectorAll('.nd-fold').forEach(function (d) { d.open = true; });
    }
  }

  /* ---------- productos recomendados (ficha) ---------- */
  function initRecommendations() {
    var el = document.querySelector('[data-recommendations]');
    if (!el) { return; }
    var url = el.getAttribute('data-url');
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('[data-recommendations]');
        if (inner && inner.innerHTML.trim()) { el.innerHTML = inner.innerHTML; }
        else { var sec = el.closest('.nd-rel'); if (sec) { sec.hidden = true; } }
      }).catch(function () {});
  }

  /* ---------- formulario de venta ---------- */
  function initSellForm() {
    var form = document.getElementById('empezar');
    var tbody = document.getElementById('nd-rows');
    if (!form || !tbody) { return; }

    function ndGoForm() {
      var t = document.getElementById('empezar');
      if (!t) { return; }
      var html = document.documentElement;
      var prev = html.style.scrollBehavior;
      html.style.scrollBehavior = 'auto';
      html.scrollTop = t.getBoundingClientRect().top + html.scrollTop - 80;
      html.style.scrollBehavior = prev;
    }
    var cta = document.querySelector('.nd-hero-cta');
    if (cta) {
      cta.addEventListener('click', function (e) {
        e.preventDefault();
        ndGoForm();
        setTimeout(ndGoForm, 300);
        var first = form.querySelector('input, select');
        if (first) { setTimeout(function () { first.focus({ preventScroll: true }); }, 340); }
      });
    }

    var tpl = document.getElementById('nd-row-tpl');
    var add = document.getElementById('nd-addrow');
    if (add && tpl) {
      add.addEventListener('click', function () {
        var tr = document.createElement('tr');
        tr.className = 'nd-row';
        tr.innerHTML = tpl.innerHTML;
        tbody.appendChild(tr);
      });
    }
    tbody.addEventListener('click', function (e) {
      var b = e.target.closest('.nd-rowdel'); if (!b) { return; }
      if (tbody.querySelectorAll('.nd-row').length > 1) { b.closest('tr').remove(); }
      else { b.closest('tr').querySelectorAll('input').forEach(function (i) { i.value = ''; }); }
    });

    // Antes de enviar: volcar las filas en un único campo de texto (viaja en el email).
    form.addEventListener('submit', function (e) {
      var out = form.querySelector('[data-cards-field]');
      var lines = [];
      var n = 0;
      tbody.querySelectorAll('.nd-row').forEach(function (tr) {
        var g = function (s) { var el = tr.querySelector(s); return el ? el.value.trim() : ''; };
        var name = g('[data-c=name]');
        if (!name) { return; }
        n++;
        lines.push(n + ') ' + name + ' · Set: ' + g('[data-c=set]') + ' · Nº: ' + g('[data-c=num]') + ' · Idioma: ' + g('[data-c=lang]') + ' · Estado: ' + g('[data-c=cond]'));
      });
      if (!n) {
        e.preventDefault();
        var msg = form.querySelector('.nd-sell-err');
        if (msg) { msg.hidden = false; }
        ndGoForm();
        return;
      }
      if (out) { out.value = lines.join('\n'); }
    });
  }

  /* ---------- EVENTOS: calendario ---------- */
  var MESES = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
  function parseFecha(str) {
    var p = (str || '').split('-');
    if (p.length !== 3) { return null; }
    return new Date(+p[0], +p[1] - 1, +p[2]);
  }
  function ymd(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }
  function initCalendario(wrap) {
    var data;
    try { data = JSON.parse(wrap.getAttribute('data-cal') || '[]'); } catch (e) { data = []; }
    var elTitle = wrap.querySelector('.nd-ev-cal-title');
    var elDays = wrap.querySelector('.nd-ev-cal-days');
    var elClear = wrap.querySelector('.nd-ev-clear');
    var elNoday = wrap.querySelector('.nd-ev-noday');
    if (!elDays) { return; }

    var porFecha = {};
    data.forEach(function (ev) { if (!ev.fecha) { return; } (porFecha[ev.fecha] = porFecha[ev.fecha] || []).push(ev); });

    var hoy = parseFecha(wrap.getAttribute('data-hoy')) || new Date();
    var vista = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
    var activo = null;

    function render() {
      var year = vista.getFullYear(), month = vista.getMonth();
      elTitle.textContent = MESES[month] + ' ' + year;
      elDays.innerHTML = '';
      var inicio = (new Date(year, month, 1).getDay() + 6) % 7;
      var dias = new Date(year, month + 1, 0).getDate();
      for (var i = 0; i < inicio; i++) { var vacio = document.createElement('div'); vacio.className = 'nd-ev-day is-empty'; elDays.appendChild(vacio); }
      for (var d = 1; d <= dias; d++) {
        var fecha = year + '-' + String(month + 1).padStart(2, '0') + '-' + String(d).padStart(2, '0');
        var cell = document.createElement('div');
        cell.className = 'nd-ev-day';
        cell.textContent = d;
        if (fecha === ymd(hoy)) { cell.classList.add('is-today'); }
        var evs = porFecha[fecha];
        if (evs && evs.length) {
          cell.classList.add('has-ev');
          cell.setAttribute('data-fecha', fecha);
          cell.title = evs.map(function (e) { return e.title; }).join(', ');
          var dots = document.createElement('div');
          dots.className = 'nd-ev-dots';
          var colores = [];
          evs.forEach(function (e) { if (colores.indexOf(e.color) < 0 && colores.length < 3) { colores.push(e.color); } });
          colores.forEach(function (c) { var i2 = document.createElement('i'); i2.style.background = c; dots.appendChild(i2); });
          cell.appendChild(dots);
          if (fecha === activo) { cell.classList.add('is-active'); }
          cell.addEventListener('click', function () { toggleDia(this.getAttribute('data-fecha')); });
        }
        elDays.appendChild(cell);
      }
    }
    function toggleDia(fecha) { activo = (activo === fecha) ? null : fecha; aplicarFiltro(); render(); }
    function aplicarFiltro() {
      var cards = wrap.querySelectorAll('.nd-ev-card');
      var visibles = 0;
      cards.forEach(function (c) {
        var mostrar = !activo || c.getAttribute('data-fecha') === activo;
        c.style.display = mostrar ? '' : 'none';
        if (mostrar) { visibles++; }
      });
      if (elClear) { elClear.hidden = !activo; }
      if (elNoday) { elNoday.hidden = !(activo && visibles === 0); }
    }
    wrap.querySelectorAll('.nd-ev-nav').forEach(function (btn) {
      btn.addEventListener('click', function () { vista.setMonth(vista.getMonth() + parseInt(this.getAttribute('data-dir'), 10)); render(); });
    });
    function limpiar(e) { if (e) { e.preventDefault(); } activo = null; aplicarFiltro(); render(); }
    if (elClear) { elClear.addEventListener('click', limpiar); }
    wrap.querySelectorAll('.nd-ev-clear-inline').forEach(function (a) { a.addEventListener('click', limpiar); });
    render();
  }

  /* ---------- EVENTOS: contraste de etiquetas de tipo ---------- */
  function initBadgeContrast() {
    document.querySelectorAll('.nd-ev-badge[style]').forEach(function (b) {
      var c = b.style.getPropertyValue('--c').trim().replace('#', '');
      if (c.length === 3) { c = c[0] + c[0] + c[1] + c[1] + c[2] + c[2]; }
      if (c.length !== 6) { return; }
      var r = parseInt(c.substr(0, 2), 16), g = parseInt(c.substr(2, 2), 16), bl = parseInt(c.substr(4, 2), 16);
      b.style.setProperty('--ct', (0.299 * r + 0.587 * g + 0.114 * bl) > 160 ? '#151515' : '#ffffff');
    });
  }

  /* ---------- EVENTOS: modal de inscripción ---------- */
  function initEventModal() {
    var modal = document.querySelector('.nd-ev-modal');
    if (!modal) { return; }
    var titulo = modal.querySelector('#nd-ev-modal-t');
    var formCart = modal.querySelector('.nd-ev-form-cart');
    var formMail = modal.querySelector('.nd-ev-form-mail');
    var current = {};

    function abrir(btn) {
      current = {
        variant: btn.getAttribute('data-variant') || '',
        title: btn.getAttribute('data-title') || '',
        pago: btn.getAttribute('data-pago') === '1'
      };
      titulo.textContent = current.title;
      var useCart = !!current.variant && formCart;
      if (formCart) { formCart.hidden = !useCart; formCart.reset(); var m = formCart.querySelector('.nd-ev-form-msg'); if (m) { m.textContent = ''; m.className = 'nd-ev-form-msg'; } }
      if (formMail) { formMail.hidden = !!useCart; formMail.reset(); var ev = formMail.querySelector('[name="contact[Evento]"]'); if (ev) { ev.value = current.title; } }
      if (useCart) {
        var sb = formCart.querySelector('.nd-ev-submit');
        sb.textContent = current.pago ? 'Ir a pagar →' : 'Confirmar inscripción';
        var hint = formCart.querySelector('.nd-ev-hint');
        if (hint) { hint.textContent = current.pago ? 'Tu plaza se confirma al completar el pago.' : 'Tu plaza se confirma al finalizar el proceso (sin coste).'; }
      }
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function cerrar() { modal.hidden = true; document.body.style.overflow = ''; }

    document.addEventListener('click', function (e) {
      var open = e.target.closest('.nd-ev-open');
      if (open) { abrir(open); }
      if (e.target.closest('.nd-ev-modal-x') || e.target.classList.contains('nd-ev-modal-back')) { cerrar(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) { cerrar(); } });

    if (formCart) {
      formCart.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = formCart.querySelector('.nd-ev-submit');
        var msg = formCart.querySelector('.nd-ev-form-msg');
        btn.disabled = true;
        msg.className = 'nd-ev-form-msg';
        msg.textContent = 'Reservando tu plaza…';
        var fd = new FormData();
        fd.append('id', current.variant);
        fd.append('quantity', '1');
        fd.append('properties[Evento]', current.title);
        fd.append('properties[Nombre]', formCart.querySelector('[name=nombre]').value);
        fd.append('properties[Email]', formCart.querySelector('[name=email]').value);
        fd.append('properties[Teléfono]', formCart.querySelector('[name=telefono]').value);
        fetch(ND.cartAddUrl || '/cart/add.js', { method: 'POST', credentials: 'same-origin', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            if (!res.ok) { throw new Error(res.data && (res.data.description || res.data.message) || 'Error'); }
            msg.className = 'nd-ev-form-msg ok';
            msg.textContent = 'Te llevamos a confirmar tu plaza…';
            window.location.href = '/checkout';
          })
          .catch(function (err) {
            btn.disabled = false;
            msg.className = 'nd-ev-form-msg err';
            msg.textContent = /stock|inventario|available|disponible/i.test(err.message) ? 'Lo sentimos, este evento está completo.' : (err.message || 'Error al inscribirse.');
          });
      });
    }
    // Si la página vuelve tras enviar el formulario por email, abrir el modal con el aviso.
    if (modal.querySelector('[data-ev-posted]')) {
      modal.hidden = false;
      if (formCart) { formCart.hidden = true; }
      if (formMail) { formMail.hidden = false; }
    }
  }

  /* ---------- EVENTOS: cuenta atrás ---------- */
  function initCountdown() {
    var el = document.querySelector('.nd-evp-count');
    if (!el) { return; }
    var target = el.getAttribute('data-target');
    if (!target) { return; }
    var fin = new Date(target.replace(' ', 'T')).getTime();
    if (isNaN(fin)) { return; }
    var b = { d: el.querySelector('[data-c=d]'), h: el.querySelector('[data-c=h]'), m: el.querySelector('[data-c=m]'), s: el.querySelector('[data-c=s]') };
    var boxes = el.querySelector('.nd-evp-count-boxes');
    var kick = el.querySelector('.nd-evp-count-kick');
    var done = el.querySelector('.nd-evp-count-done');
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var diff = fin - Date.now();
      if (diff <= 0) {
        if (boxes) { boxes.style.display = 'none'; }
        if (kick) { kick.style.display = 'none'; }
        if (done) { done.hidden = false; }
        clearInterval(t);
        return;
      }
      if (b.d) { b.d.textContent = Math.floor(diff / 86400000); }
      if (b.h) { b.h.textContent = pad(Math.floor(diff % 86400000 / 3600000)); }
      if (b.m) { b.m.textContent = pad(Math.floor(diff % 3600000 / 60000)); }
      if (b.s) { b.s.textContent = pad(Math.floor(diff % 60000 / 1000)); }
    }
    tick();
    var t = setInterval(tick, 1000);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initCookies();
    initPopup();
    initAjaxCart();
    initGallery();
    initSort();
    initRecommendations();
    initSellForm();
    var wrap = document.querySelector('.nd-ev-wrap');
    if (wrap) { initCalendario(wrap); }
    initBadgeContrast();
    initEventModal();
    initCountdown();
  });
})();
